import type {
  ResourceFilterStatus,
  SearchMembershipsSearchParams,
  TeamLookupExpand,
  TeamSearchParams,
} from '@/common/api/types/teams';

export const teamsQueryKeys = {
  all: () => ['teams'],
  byLoopAll: () => ['teams', 'loop'],
  byLoop: (loopId: string) => [...teamsQueryKeys.byLoopAll(), loopId],
  teamInfo: () => ['teamInfo'],
  teamScope: (teamId?: number | null) => ['teamInfo', teamId],
  team: ({
    teamId,
    resourceStatus,
  }: {
    teamId?: number | null;
    resourceStatus?: ResourceFilterStatus;
  }) => [...teamsQueryKeys.teamScope(teamId), resourceStatus],
  searchAll: () => ['teams', 'search'],
  search: (params: TeamSearchParams = {}) => [
    ...teamsQueryKeys.searchAll(),
    {
      query: params.query?.trim() ?? '',
      sortBy: params.sortBy ?? 'NAME',
      sortDirection: params.sortDirection ?? 'ASC',
      loopIds: params.loopIds ?? [],
      skillIds: params.skillIds ?? [],
    },
    params.roleIds ?? [],
  ],
  searchTeamMembers: ({
    teamId,
    searchParams,
  }: {
    teamId?: number | null;
    searchParams: SearchMembershipsSearchParams | undefined;
  }) => [...teamsQueryKeys.teamScope(teamId), searchParams],
  importTeamsSearch: ({ sourceType, instanceId }: { sourceType?: string; instanceId?: string }) => [
    'importTeamsSearch',
    {
      sourceType,
      instanceId,
    },
  ],
  lookupAll: () => ['teamsLookup'],
  lookup: ({
    ids,
    dateRange,
    teamRoleIds,
    skillIds,
    loopId,
    expand,
  }: {
    ids: number[];
    dateRange: { from: string; to: string } | undefined;
    teamRoleIds?: number[];
    skillIds?: number[];
    loopId?: string;
    expand?: TeamLookupExpand[];
  }) => [
    ...teamsQueryKeys.lookupAll(),
    {
      ids,
      dateRange,
      teamRoleIds,
      skillIds,
      loopId: loopId ?? null,
      expand,
    },
  ],
  portfolioChangeEligibility: (teamId: number) =>
    ['teamInfo', teamId, 'portfolio-change-eligibility'] as const,
  syncStatus: () => ['teamsSyncStatus'],
  teamImportingCount: () => ['teamsImportingCount'],
  resourceMemberships: {
    all: () => ['resourceTeamMemberships'],
    detail: (resourceId: number) => ['resourceTeamMemberships', resourceId],
  },
  membershipPreview: (params: {
    teamId: number;
    resourceId: number;
    suggestedCommitment?: number;
  }) => ['membershipPreview', params] as const,
  membershipOverridePreview: (params: { membershipId: number; commitment?: number }) =>
    ['membershipOverridePreview', params] as const,
};
